webpackJsonpUpdateBris([45],{

/***/ 357:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.MailingListCdc = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _cdc = __webpack_require__(409);

var _cdc2 = _interopRequireDefault(_cdc);

var _constants = __webpack_require__(145);

var _utils = __webpack_require__(4);

var utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// CONSTANTS are all caps.
var NS = 'MailingListCdc';
var CLS = 'mailingListCdc';
var BLK = '.' + CLS + '-';
var TYPE_MESSAGE = {
	CustomerInCDCAndOptInExistInEmarsysMessage: 'CustomerInCDCAndOptInExistInEmarsysMessage',
	CustomerInCDCAndOptInNotExistInEmarsysMessage: 'CustomerInCDCAndOptInNotExistInEmarsysMessage',
	CustomerNotInCDCAndOptInNotExistInEmarsysMessage: 'CustomerNotInCDCAndOptInNotExistInEmarsysMessage'
};

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out ./loadBlk.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'


var MailingListCdc = exports.MailingListCdc = function (_CDC) {
	_inherits(MailingListCdc, _CDC);

	function MailingListCdc(el) {
		_classCallCheck(this, MailingListCdc);

		var _this = _possibleConstructorReturn(this, (MailingListCdc.__proto__ || Object.getPrototypeOf(MailingListCdc)).call(this, el));

		_this.cdcService = new _cdc.CdcService();
		_this.typeMessage = TYPE_MESSAGE.CustomerNotInCDCAndOptInNotExistInEmarsysMessage;
		_this.validate = {
			'profile.email': ['required', 'email']
		};
		return _this;
	}

	_createClass(MailingListCdc, [{
		key: 'init',
		value: function init() {}
	}, {
		key: '_onAfterScreenLoad',
		value: function _onAfterScreenLoad() {
			this.$blockQuery.find('input[name="profile.firstName"], input[name="profile.lastName"], input[name="profile.email"]').val('');
			this._showForm();
		}
	}, {
		key: '_onSubmit',
		value: function _onSubmit(event) {
			utils.showLoading();
			return this.checkTypeMessage(event).finally(function () {
				utils.hideLoading();
			});
		}
	}, {
		key: 'onAfterSubmit',
		value: function onAfterSubmit(response) {
			var status = response.status;
			var UID = response.UID;
			window.dataLayer = window.dataLayer || [];
			if (status === 'OK') {
				this.renderMessage(this.typeMessage);
				window.dataLayer.push({
					'event': 'signUp',
					'eventCategory': 'Sign Up',
					'eventAction': 'Email Updates',
					'userId': UID
				});
			}
		}
	}, {
		key: 'updateFormData',
		value: function updateFormData(event) {
			var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

			var customerTypeCode = 'customerTypeCode';
			event.formModel.data[customerTypeCode] = data.CustomerTypeCode || event.formModel.data[customerTypeCode] || _constants.CDC_ACCOUNT_DATA.CUSTOMER_TYPE_CODE;
			data[_constants.STAFF_CARD_NO_OPT] && (event.formModel.data[_constants.STAFF_CARD_NO] = data[_constants.STAFF_CARD_NO_OPT]);
			this.cdcService.setAcquisitionChannel(event, data, _constants.CDC_ACCOUNT_DATA.ACQUISITION_CHANNEL_FOOTER, true);
		}
	}, {
		key: 'checkTypeMessage',
		value: function checkTypeMessage(event) {
			var _this2 = this;

			return new Promise(function (resolve, reject) {
				var email = event.formModel.profile.email;
				var setAccountInfo = function setAccountInfo() {
					_this2.cdcService.setAccountInfoWithToken(event.formModel).then(function (res) {
						_this2.onAfterSubmit(res);
					}).finally(function () {
						reject();
					});
				};

				_this2.cdcService.searchAccountByEmail(email).then(function (data) {
					if (data) {
						if (data.OptIn) {
							_this2.typeMessage = TYPE_MESSAGE.CustomerInCDCAndOptInExistInEmarsysMessage;
						} else {
							_this2.typeMessage = TYPE_MESSAGE.CustomerInCDCAndOptInNotExistInEmarsysMessage;
						}
					} else {
						_this2.typeMessage = TYPE_MESSAGE.CustomerNotInCDCAndOptInNotExistInEmarsysMessage;
					}
					_this2.updateFormData(event, data || {});
					setAccountInfo();
				}).catch(function () {
					setAccountInfo();
				});
			});
		}
	}, {
		key: 'renderMessage',
		value: function renderMessage(typeMessage) {
			this.$blockQuery.css('display', 'none');
			this.$blockQuery.closest('.mailinglistblock').find('.message-mailing[data-key="' + typeMessage + '"]').css('display', 'block');
		}
	}]);

	return MailingListCdc;
}(_cdc2.default);

/***/ }),

/***/ 406:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.saveSelectedStore = saveSelectedStore;
exports.checkLocalStorage = checkLocalStorage;
exports.convertStore = convertStore;
exports.storeNameShorter = storeNameShorter;

var _api = __webpack_require__(144);

var Api = _interopRequireWildcard(_api);

var _cdc = __webpack_require__(409);

var _utils = __webpack_require__(4);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var NS = 'findInStore';

function saveSelectedStore(store, successCB) {
	var cdcService = new _cdc.CdcService();
	var saveToLocalStorage = function saveToLocalStorage() {
		if (!window.localStorage) return;

		store = convertStore(store);

		window.localStorage.setItem('bris.' + NS + '.value', JSON.stringify(store));
	};

	var saveToDb = function saveToDb() {
		var endpoint = $('.endpoints-definition').data('set-store-endpoint');
		if (!endpoint) {
			console.error('"data-select-store-endpoint" couldn\'t find. Please set the endpoint on "endpoints-definition". Returned early.');
		}

		var param = {
			storeId: store.storeId
		};

		window.gigya && cdcService.setStoreById(store.storeId);

		Api.callApi(endpoint, param).then(function (data) {
			saveToLocalStorage();
			if (data.result == 'SUCCESS') {
				if (successCB) {
					successCB();
				}
			} else {
				console.error(data.message || 'Find in store. Error set store.');
			}
		}).catch(saveToLocalStorage);
	};

	saveToDb();
}

function checkLocalStorage() {
	var data = {
		storeInfo: {
			storeId: '',
			storeName: '',
			contentLinkID: '',
			regionId: '',
			branchSearch: ''
		}
	};

	if ((0, _utils.isLoggedin)() && window.selectedStore && window.localStorage) {
		var storeInfo = {
			storeName: storeNameShorter(window.selectedStore.name),
			storeId: window.selectedStore.fulfilmentNumber,
			contentLinkID: window.selectedStore.contentLinkID
		};
		window.localStorage.setItem('bris.' + NS + '.value', JSON.stringify(storeInfo));
		delete window.selectedStore;
	}
	if (window.localStorage) {
		var storeValue = window.localStorage.getItem('bris.' + NS + '.value');
		if (storeValue) {
			data.storeInfo = JSON.parse(storeValue);
			data.storeInfo.store = convertStore(data.storeInfo.store);
		}
	}

	return data;
}

function convertStore(store) {
	if (store && store.storeName) {
		store.storeName = storeNameShorter(store.storeName);
	}
	return store;
}

function storeNameShorter(name) {
	return name.replace('Briscoes ', '').replace('Rebel Sport ', '').replace('Living & Giving ', '').replace('Living &amp; Giving ', '');
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),

/***/ 409:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CdcService = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _api = __webpack_require__(144);

var _constants = __webpack_require__(145);

var _utils = __webpack_require__(4);

var utils = _interopRequireWildcard(_utils);

var _lodash = __webpack_require__(5);

var _lodash2 = _interopRequireDefault(_lodash);

var _findInStore = __webpack_require__(406);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CDC = function () {
    function CDC($el) {
        _classCallCheck(this, CDC);

        this.$el = $el;
        this.$blockQuery = $($el);
        this.successUrl = $(this.$el).attr('success-url');
        this._messageSelecter = '#errorMessageCDC';
        this._site = $('body').hasClass('is-bris') ? 'briscoes' : 'rebel';
        this._extendField = $('body').hasClass('is-bris') ? 'Briscoes' : 'Rebel';
        this._initCDC($el);
        this.$el.cdc = this;
    }

    _createClass(CDC, [{
        key: '_initCDC',
        value: function _initCDC($el) {
            var screenSet = $($el).attr('screen-set');
            var startScreen = $($el).attr('start-screen');
            var containerID = $($el).attr('id');

            startScreen && utils.showScreenSet({
                screenSet: screenSet,
                startScreen: startScreen,
                containerID: containerID,
                onAfterScreenLoad: typeof this['_onAfterScreenLoad'] === 'function' ? this['_onAfterScreenLoad'].bind(this) : function () {},
                onSubmit: typeof this['_onSubmit'] === 'function' ? this['_onSubmit'].bind(this) : function () {},
                onFieldChanged: typeof this['_onFieldChanged'] === 'function' ? this['_onFieldChanged'].bind(this) : function () {},
                onBeforeValidation: this._customValidation.bind(this),
                onAfterSubmit: typeof this['_onAfterSubmit'] === 'function' ? this['_onAfterSubmit'].bind(this) : function () {}
            });
            this._registerEvent();
        }
    }, {
        key: '_customValidation',
        value: function _customValidation(form) {
            var _this = this;

            var formData = form.formData;
            var beforeValidate = {};

            return new Promise(function (resolve) {
                if (typeof _this['validate'] !== 'undefined') {
                    var _loop = function _loop(key, validates) {
                        if (typeof formData[key] !== 'undefined') {
                            validates.forEach(function (validate) {
                                var value = formData[key];
                                if (typeof validate === 'function') {
                                    var errorMessage = validate(form);
                                    if (errorMessage) {
                                        beforeValidate[key] = errorMessage;
                                    }
                                } else {
                                    switch (validate) {
                                        case 'required':
                                            if (utils.isNullOrWhiteSpace(value)) {
                                                beforeValidate[key] = 'This field is required';
                                            }
                                            break;

                                        case 'mobile-number':
                                            if (value) {
                                                if (!/^[a-zA-Z0-9]*$/.test(value)) {
                                                    beforeValidate[key] = 'Please remove any special characters';
                                                } else if (!/^[0-9]*$/.test(value)) {
                                                    beforeValidate[key] = 'Please enter a valid phone number';
                                                } else if (!/^0[0-9]*$/.test(value)) {
                                                    beforeValidate[key] = 'Phone number should begin with 0';
                                                } else if (/^0[0-9]*$/.test(value) && !/^.{7,12}$/.test(value)) {
                                                    beforeValidate[key] = 'Phone should be within 7 and 12 numbers';
                                                }
                                            }
                                            break;

                                        case 'password':
                                            if (value) {
                                                if (!/^.{8,}$/.test(value)) {
                                                    beforeValidate[key] = 'The password you entered does not meet the minimum length of 8 characters. Please enter a valid password.';
                                                } else if (!/^.{8,64}$/.test(value)) {
                                                    beforeValidate[key] = 'The password you entered exceeds the maximum length of 64 characters. Please enter a valid password.';
                                                } else if (!/(?=.*[A-Z])/.test(value)) {
                                                    beforeValidate[key] = 'The password you entered does not contain at least one uppercase letter. Please enter a valid password.';
                                                } else if (!/(?=.*[a-z])/.test(value)) {
                                                    beforeValidate[key] = 'The password you entered does not contain at least one lowercase letter. Please enter a valid password.';
                                                } else if (!/(?=.*\d)/.test(value)) {
                                                    beforeValidate[key] = 'The password you entered does not contain at least one number. Please enter a valid password.';
                                                }
                                            }
                                            break;

                                        case 'first-name':
                                            if (value) {
                                                if (!/^.{0,50}$/.test(value)) {
                                                    beforeValidate[key] = 'The first name you entered exceeds the maximum length of 50 characters.';
                                                }
                                            }
                                            break;

                                        case 'last-name':
                                            if (value) {
                                                if (!/^.{0,50}$/.test(value)) {
                                                    beforeValidate[key] = 'The last name you entered exceeds the maximum length of 50 characters.';
                                                }
                                            }
                                            break;

                                        case 'email':
                                            if (value) {
                                                if (!/^(?!.*\.\@)(?!.*[.!#$%&'*+/=?^_`{|}~-]{2})(?!.*[.!#$%&'*+/=?^_`{|}~-]$)(?!^[.!#$%&'*+/=?^_`{|}~-])[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]{1,64}@[a-zA-Z0-9]+([.-]?[a-zA-Z0-9]+)*\.[a-zA-Z]{2,}$/.test(value)) {
                                                    beforeValidate[key] = 'Please enter a valid email address';
                                                }
                                            }
                                            break;

                                        default:
                                            break;
                                    }
                                }
                            });
                        }
                    };

                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = Object.entries(_this.validate)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var _ref = _step.value;

                            var _ref2 = _slicedToArray(_ref, 2);

                            var key = _ref2[0];
                            var validates = _ref2[1];

                            _loop(key, validates);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
                resolve(typeof _this['_onBeforeValidation'] === 'function' ? _this['_onBeforeValidation'].bind(_this)(beforeValidate, form) : beforeValidate);
            });
        }
    }, {
        key: '_registerEvent',
        value: function _registerEvent() {
            window.gigya && window.gigya.socialize.addEventHandlers({
                onAfterResponse: this._onAfterResponse.bind(this)
            });
        }
    }, {
        key: '_onAfterResponse',
        value: function _onAfterResponse(data) {
            var methodName = data.methodName,
                response = data.response;

            if (typeof this[methodName] === 'function') {
                var promise = new Promise(function (resolve, reject) {
                    var errorCode = response.errorCode;

                    if (errorCode == _constants.CDC_ERROR_CODE.SUCCESS) {
                        resolve(data);
                    } else {
                        reject(data);
                    }
                });
                this[methodName](promise, data);
            }
        }
    }, {
        key: '_showMessage',
        value: function _showMessage(message) {
            utils.hideLoading();
            var $message = $(this._messageSelecter);
            if (message && $message.length) {
                $message.html('');
                if ((typeof message === 'undefined' ? 'undefined' : _typeof(message)) === 'object') {
                    var $ul = $('<ul>');
                    $ul.html(message.map(function (item) {
                        var $li = $('<li>');
                        $li.text(item);
                        return $li;
                    }));
                    $message.html($ul);
                } else {
                    $message.html(message);
                }
                $message.addClass('is-active');
            }
        }
    }, {
        key: '_hideMessage',
        value: function _hideMessage() {
            var $message = $(this._messageSelecter);
            $message.removeClass('is-active');
        }
    }, {
        key: '_showForm',
        value: function _showForm() {
            var _this2 = this;

            if (this._loading) {
                this._loading.$spinner.hide(0, function () {
                    return _this2._loading.$content.show();
                });
            }
        }
    }, {
        key: '_replaceLink',
        value: function _replaceLink($element, link) {
            $element.length && utils.replaceElemnt($element[0]).addEventListener('click', function () {
                window.location.href = link;
            });
        }
    }, {
        key: '_saveIdToken',
        value: function _saveIdToken(token) {
            window.localStorage && window.localStorage.setItem('bris.cdc.token', token);
        }
    }, {
        key: '_renderFieldError',
        value: function _renderFieldError(fieldName) {
            var errorCode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            var message = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

            var $form = $(this.$el).find('form[data-screenset-roles]:visible');
            $form.length && $form[0].screenSetInstanceOf[0].renderFieldError({
                errorCode: errorCode,
                fieldName: fieldName
            }, true, message);
        }
    }, {
        key: '_reset',
        value: function _reset() {
            var $form = $(this.$el).find('form[data-screenset-roles]:visible');
            $form.length && $form[0].reset();
        }
    }, {
        key: '_renderLocalStore',
        value: function _renderLocalStore() {
            var selected = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
            var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

            if (utils.enableRenderStore()) {
                var $localStore = $(this.$el).find('[name="' + _constants.CDC_LOCAL_STORE[this._site] + '"]:visible');
                if ($localStore.length) {
                    var $option = function $option(name, value) {
                        return $('<option value="' + value + '" data-screenset-element-id-publish="false" data-screenset-roles="instance">' + name + '</option>');
                    };
                    var $optionList = utils.getStoreList(defaults).map(function (store) {
                        return $option(store.name, store.storeId);
                    });
                    $localStore.html($optionList);
                    selected && $localStore.val(selected);
                }
            }
        }
    }]);

    return CDC;
}();

exports.default = CDC;

var CdcService = exports.CdcService = function () {
    function CdcService() {
        _classCallCheck(this, CdcService);

        this.site = $('body').hasClass('is-bris') ? 'briscoes' : 'rebel';
    }

    _createClass(CdcService, [{
        key: 'isAvailableLoginID',
        value: function isAvailableLoginID(parameters) {
            var _this3 = this;

            return new Promise(function (resolve, reject) {
                window.gigya.accounts.isAvailableLoginID(_lodash2.default.merge(parameters, {
                    callback: function callback(data) {
                        _this3.verifyResponse(data, resolve, reject);
                    }
                }));
            });
        }
    }, {
        key: 'initRegistration',
        value: function initRegistration() {
            var _this4 = this;

            var parameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            return new Promise(function (resolve, reject) {
                window.gigya.accounts.initRegistration(_lodash2.default.merge(parameters, {
                    callback: function callback(data) {
                        _this4.verifyResponse(data, resolve, reject);
                    }
                }));
            });
        }
    }, {
        key: 'register',
        value: function register(parameters) {
            var _this5 = this;

            return new Promise(function () {
                var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(resolve, reject) {
                    var _ref4, regToken;

                    return regeneratorRuntime.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    _context.next = 2;
                                    return _this5.initRegistration();

                                case 2:
                                    _ref4 = _context.sent;
                                    regToken = _ref4.regToken;

                                    window.gigya.accounts.register(_lodash2.default.merge(parameters, {
                                        regToken: regToken,
                                        callback: function callback(data) {
                                            _this5.verifyResponse(data, resolve, reject);
                                        }
                                    }));

                                case 5:
                                case 'end':
                                    return _context.stop();
                            }
                        }
                    }, _callee, _this5);
                }));

                return function (_x6, _x7) {
                    return _ref3.apply(this, arguments);
                };
            }());
        }
    }, {
        key: 'setAccountInfoLite',
        value: function setAccountInfoLite(parameters) {
            var _this6 = this;

            return new Promise(function () {
                var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(resolve, reject) {
                    var _ref6, regToken;

                    return regeneratorRuntime.wrap(function _callee2$(_context2) {
                        while (1) {
                            switch (_context2.prev = _context2.next) {
                                case 0:
                                    parameters.callback = function (data) {
                                        _this6.verifyResponse(data, resolve, reject);
                                    };
                                    _context2.next = 3;
                                    return _this6.initRegistration({ isLite: true });

                                case 3:
                                    _ref6 = _context2.sent;
                                    regToken = _ref6.regToken;

                                    parameters.regToken = regToken;
                                    window.gigya.accounts.setAccountInfo(parameters);

                                case 7:
                                case 'end':
                                    return _context2.stop();
                            }
                        }
                    }, _callee2, _this6);
                }));

                return function (_x8, _x9) {
                    return _ref5.apply(this, arguments);
                };
            }());
        }
    }, {
        key: 'setAccountInfo',
        value: function setAccountInfo(parameters) {
            var _this7 = this;

            return new Promise(function () {
                var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(resolve, reject) {
                    return regeneratorRuntime.wrap(function _callee3$(_context3) {
                        while (1) {
                            switch (_context3.prev = _context3.next) {
                                case 0:
                                    parameters.callback = function (data) {
                                        _this7.verifyResponse(data, resolve, reject);
                                    };
                                    window.gigya.accounts.setAccountInfo(parameters);

                                case 2:
                                case 'end':
                                    return _context3.stop();
                            }
                        }
                    }, _callee3, _this7);
                }));

                return function (_x10, _x11) {
                    return _ref7.apply(this, arguments);
                };
            }());
        }
    }, {
        key: 'setAccountInfoWithToken',
        value: function setAccountInfoWithToken(parameters) {
            var _this8 = this;

            return new Promise(function () {
                var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(resolve, reject) {
                    var _ref9, regToken;

                    return regeneratorRuntime.wrap(function _callee4$(_context4) {
                        while (1) {
                            switch (_context4.prev = _context4.next) {
                                case 0:
                                    parameters.callback = function (data) {
                                        _this8.verifyResponse(data, resolve, reject);
                                    };
                                    _context4.next = 3;
                                    return _this8.initRegToken();

                                case 3:
                                    _ref9 = _context4.sent;
                                    regToken = _ref9.regToken;

                                    parameters.regToken = regToken;
                                    window.gigya.accounts.setAccountInfo(parameters);

                                case 7:
                                case 'end':
                                    return _context4.stop();
                            }
                        }
                    }, _callee4, _this8);
                }));

                return function (_x12, _x13) {
                    return _ref8.apply(this, arguments);
                };
            }());
        }
    }, {
        key: 'initRegToken',
        value: function initRegToken() {
            var _window$gigya = window.gigya,
                apiKey = _window$gigya.apiKey,
                defaultApiDomain = _window$gigya.defaultApiDomain,
                dataCenter = _window$gigya.dataCenter;

            var initRegistrationEndpoint = 'https://accounts.' + dataCenter + '.' + defaultApiDomain + '/accounts.initRegistration?apiKey=' + apiKey + '&isLite=true';

            return fetch(initRegistrationEndpoint, { method: 'POST' }).then(function (response) {
                return response.json();
            }).then(function (response) {
                return Promise.resolve(response);
            });
        }
    }, {
        key: 'updateLocalStore',
        value: function updateLocalStore(data) {
            var _this9 = this;

            var _checkLocalStorage = (0, _findInStore.checkLocalStorage)(),
                storeId = _checkLocalStorage.storeInfo.storeId;

            var storeIdCDC = _lodash2.default.get(data, 'response.data.localStore' + { briscoes: 'Briscoes', rebel: 'Rebel' }[this.site], 0);

            return new Promise(function (resolve) {
                if (storeId && storeId !== storeIdCDC) {
                    var parameters = {
                        data: _defineProperty({}, 'localStore' + { briscoes: 'Briscoes', rebel: 'Rebel' }[_this9.site], storeId),
                        callback: function callback() {
                            resolve(data);
                        }
                    };
                    window.gigya.accounts.setAccountInfo(parameters);
                } else {
                    resolve(data);
                }
            });
        }
    }, {
        key: 'verifyLogin',
        value: function verifyLogin() {
            var _this10 = this;

            return new Promise(function (resolve, reject) {
                window.gigya.accounts.verifyLogin({
                    callback: function callback(data) {
                        _this10.verifyResponse(data, resolve, reject);
                    }
                });
            });
        }
    }, {
        key: 'getJWT',
        value: function getJWT() {
            var _this11 = this;

            return new Promise(function (resolve, reject) {
                window.gigya.accounts.getJWT({
                    callback: function callback(data) {
                        _this11.verifyResponse(data, resolve, reject);
                    }
                });
            });
        }
    }, {
        key: 'getAccountInfo',
        value: function getAccountInfo() {
            var _this12 = this;

            return new Promise(function () {
                var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(resolve, reject) {
                    var _ref11, id_token;

                    return regeneratorRuntime.wrap(function _callee5$(_context5) {
                        while (1) {
                            switch (_context5.prev = _context5.next) {
                                case 0:
                                    _context5.next = 2;
                                    return _this12.getJWT();

                                case 2:
                                    _ref11 = _context5.sent;
                                    id_token = _ref11.id_token;

                                    window.gigya.accounts.getAccountInfo({
                                        include: 'profile,data,preferences, emails',
                                        extraProfileFields: 'phones', // Default get account info note included phones.
                                        callback: function callback(data) {
                                            data.idToken = id_token;
                                            _this12.verifyResponse(data, resolve, reject);
                                        }
                                    });

                                case 5:
                                case 'end':
                                    return _context5.stop();
                            }
                        }
                    }, _callee5, _this12);
                }));

                return function (_x14, _x15) {
                    return _ref10.apply(this, arguments);
                };
            }());
        }
    }, {
        key: 'getAccountInfoWithConfig',
        value: function getAccountInfoWithConfig() {
            var _this13 = this;

            var include = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
            var extraProfileFields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

            return new Promise(function (resolve, reject) {
                window.gigya.accounts.getAccountInfo({
                    include: include,
                    extraProfileFields: extraProfileFields, // Default get account info note included phones.
                    callback: function callback(data) {
                        _this13.verifyResponse(data, resolve, reject);
                    }
                });
            });
        }
    }, {
        key: 'getAddress',
        value: function getAddress() {
            var _this14 = this;

            return new Promise(function (resolve) {
                _this14.getAccountInfoWithConfig('data').then(function (res) {
                    resolve(_lodash2.default.get(res, 'data.address'), []);
                }).catch(function () {
                    resolve([]);
                });
            });
        }
    }, {
        key: 'getDeliveryPostcode',
        value: function getDeliveryPostcode() {
            var _this15 = this;

            return new Promise(function (resolve, reject) {
                _this15.getAddress().then(function (address) {
                    var shipping = address.find(function (_ref12) {
                        var shippingDefault = _ref12.shippingDefault;
                        return shippingDefault;
                    });
                    if (shipping) {
                        var postCode = shipping.postCode;

                        if (postCode) {
                            resolve(shipping);
                        }
                    } else {
                        reject();
                    }
                });
            });
        }
    }, {
        key: 'setDeliveryPostcode',
        value: function setDeliveryPostcode() {
            var postCode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _lodash2.default.get(window, 'postcodeDelivery.value', '');

            window.localStorage && window.localStorage.setItem(_constants.LOCAL_STORE_POSTCODE, postCode);
            $('.siteHeader-modalDetail .selected-postcode').html(postCode);
            $('#input-search-postcode').val(postCode);
        }
    }, {
        key: 'getDeliveryGlobalPostcode',
        value: function getDeliveryGlobalPostcode() {
            var postCode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _lodash2.default.get(window, 'postcodeDelivery.value', '');

            return window.localStorage.getItem(_constants.LOCAL_STORE_POSTCODE) || postCode;
        }
    }, {
        key: 'setStoreById',
        value: function setStoreById(storeId) {
            var _this16 = this;

            return new Promise(function (resolve) {
                var parameters = {
                    data: _defineProperty({}, 'localStore' + { briscoes: 'Briscoes', rebel: 'Rebel' }[_this16.site], storeId),
                    callback: resolve
                };
                window.gigya.accounts.setAccountInfo(parameters);
            });
        }
    }, {
        key: 'replaceEmail',
        value: function replaceEmail(responseAccountInfo) {
            var email = _lodash2.default.get(responseAccountInfo, 'profile.email');
            var emails = _lodash2.default.get(responseAccountInfo, 'emails');
            var removeLoginEmails = _lodash2.default.concat(emails.unverified, emails.verified).filter(function (item) {
                return (item || '').toLocaleLowerCase() !== (email || '').toLocaleLowerCase();
            }).join(',');

            return new Promise(function (resolve) {
                if (removeLoginEmails) {
                    window.gigya.accounts.setAccountInfo({
                        removeLoginEmails: removeLoginEmails,
                        callback: resolve
                    });
                } else {
                    resolve();
                }
            });
        }
    }, {
        key: 'getParameterEmailSubscribe',
        value: function getParameterEmailSubscribe(isEmailSubscribe) {
            var profile = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            var _data3;

            var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
            var site = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : this.site;

            var extendField = {
                briscoes: 'Briscoes',
                rebel: 'Rebel'
            };
            var SEND_ME_ALL_THE_EMAILS = 1;
            var parameters = {
                preferences: _defineProperty({}, site, {
                    communications: {
                        email: {
                            isConsentGranted: isEmailSubscribe
                        }
                    }
                }),
                terms: _defineProperty({}, site, {
                    isConsentGranted: true
                }),
                privacy: _defineProperty({}, site, {
                    isConsentGranted: true
                }),
                data: (_data3 = {}, _defineProperty(_data3, 'customerBrand' + extendField[this.site], true), _defineProperty(_data3, 'sourceOfLastUpdate', _constants.CDC_ACCOUNT_DATA.SOURCE_OF_LAST_UPDATE), _data3)
            };

            if (data) {
                parameters.data['customerTypeCode'] = data.customerTypeCode;
                parameters.data['acquisitionChannel' + extendField[site]] = data.acquisitionChannel;
                data[_constants.STAFF_CARD_NO] && (parameters.data[_constants.STAFF_CARD_NO] = data[_constants.STAFF_CARD_NO]);
            }

            if (isEmailSubscribe) {
                parameters.data['emailFrequency' + extendField[this.site]] = SEND_ME_ALL_THE_EMAILS;
            }

            if (profile) {
                parameters.profile = profile;
            }

            return parameters;
        }
    }, {
        key: 'regsiterOpt',
        value: function regsiterOpt(parameters) {
            var _this17 = this;

            return new Promise(function (resolve, reject) {
                (0, _api.callApi)('/api/cdc/register/', parameters).then(function (data) {
                    return _this17.verifyResponse(data, resolve, reject);
                }).catch(reject);
            });
        }
    }, {
        key: 'loginOpt',
        value: function loginOpt(parameters) {
            var _this18 = this;

            return new Promise(function (resolve, reject) {
                (0, _api.callApi)('/api/cdc/login/', parameters).then(function (data) {
                    return _this18.verifyResponse(data, resolve, reject);
                }).catch(reject);
            });
        }
    }, {
        key: 'searchAccountByEmail',
        value: function searchAccountByEmail(email) {
            var _this19 = this;

            var getAccountInfoApi = function getAccountInfoApi(email) {
                return (0, _api.getApi)('/api/cdc/getaccountinfo?email=' + encodeURIComponent(email));
            };

            return new Promise(function (resolve, reject) {
                getAccountInfoApi(email).then(function (data) {
                    var emailToLowerCase = email.toLowerCase();
                    if (data || emailToLowerCase === email) {
                        return data;
                    } else {
                        return getAccountInfoApi(emailToLowerCase);
                    }
                }).then(function (data) {
                    if (data) {
                        var extendField = {
                            briscoes: 'Briscoes',
                            rebel: 'Rebel'
                        };
                        var response = _lodash2.default.merge(data, data[extendField[_this19.site]]);
                        resolve(response);
                    } else {
                        resolve(data);
                    }
                }).catch(reject);
            });
        }
    }, {
        key: 'verifyResponse',
        value: function verifyResponse(data, callback, fallback) {
            if (data.errorCode === _constants.CDC_ERROR_CODE.SUCCESS || data.result == 'SUCCESS') {
                callback(data);
            } else {
                fallback(data);
            }
        }
    }, {
        key: 'overWrite',
        value: function overWrite(data, path, fallback) {
            return _lodash2.default.get(data, path, fallback) || fallback;
        }
    }, {
        key: 'pushLastTransactedDate',
        value: function pushLastTransactedDate() {
            window.gigya && window.gigya.accounts.setAccountInfo({
                data: {
                    lastTransactedDate: (0, _moment2.default)().format('YYYY-MM-DDTHH:mm'),
                    sourceOfLastUpdate: _constants.CDC_ACCOUNT_DATA.SOURCE_OF_LAST_UPDATE
                }
            });
        }
    }, {
        key: 'setAcquisitionChannel',
        value: function setAcquisitionChannel(event, accountByEmail, channel) {
            var optIn = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

            var extendField = {
                briscoes: 'Briscoes',
                rebel: 'Rebel'
            };
            var acquisitionChannel = 'acquisitionChannel' + extendField[this.site];
            optIn = _lodash2.default.get(event.formModel, 'preferences.' + this.site + '.communications.email.isConsentGranted', optIn);

            if (accountByEmail.AcquisitionChannel) {
                event.formModel.data[acquisitionChannel] = accountByEmail.AcquisitionChannel;
            } else if (optIn) {
                event.formModel.data[acquisitionChannel] = channel;
            }
        }
    }, {
        key: 'copyDataLiteToFull',
        value: function copyDataLiteToFull(event, accountByEmail) {
            var copyBySite = {
                rebel: {
                    acquisitionChannelBriscoes: 'Briscoes.AcquisitionChannel',
                    customerRegistrationDateBriscoes: 'Briscoes.CustomerRegistrationDate',
                    lastTransactedDate: 'LastTransactedDate'
                },
                briscoes: {
                    acquisitionChannelRebel: 'Rebel.AcquisitionChannel',
                    customerRegistrationDateRebel: 'Rebel.CustomerRegistrationDate',
                    lastTransactedDate: 'LastTransactedDate'
                }
            };

            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = Object.entries(copyBySite[this.site])[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var _ref13 = _step2.value;

                    var _ref14 = _slicedToArray(_ref13, 2);

                    var cdcDataKey = _ref14[0];
                    var optiDataKey = _ref14[1];

                    var optiDataValue = _lodash2.default.get(accountByEmail, optiDataKey);
                    if (optiDataValue) {
                        event.formModel.data[cdcDataKey] = optiDataValue;
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
        }
    }]);

    return CdcService;
}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ })

});


// WEBPACK FOOTER //
// 1742452116000.blk-mailing-list-cdc-chunk.js